import React from "react";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import CustomNavPills from "components/CustomNavPills/NavPills.jsx";
import LoadingOverlay from "react-loading-overlay";
import $ from "jquery";
import DataSource from "assets/img/resources/Data_source.png";
import FS from "assets/img/resources/Field_Glossary.png";
import Rules from "assets/img/resources/Rules.png";
import DataProcessing from "assets/img/resources/Data_Processing.png";
import DataModel from "assets/img/resources/cmp_data_model.png";

class Resources extends React.Component {
  showSheets() {
    let tabs = [];
    let resourceData = {
      "Data Sources": DataSource,
      "Data Processing": DataProcessing,
      Rules: Rules,
      "Data Model": DataModel,
      "Source-to-Target Mapping": DataModel,
      "Field Glossary": FS,
    };
    $.each(resourceData, function(key, value) {
      tabs.push({
        tabButton: key,
        tabContent: <img src={value} />,
      });
    });
    return (
      <div>
        <CustomNavPills
          color="warning"
          tabs={tabs}
          className="disable-scrollbars"
        />
      </div>
    );
  }

  render() {
    let partial = this.showSheets();
    return <CardBody className="cardBodyMargin0">{partial}</CardBody>;
  }
}
export default withStyles(userProfileStyles)(Resources);



// WEBPACK FOOTER //
// ./src/views/Resources/Resources.jsx